import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Drop prerendered head tags; React re-renders them for the current route.
document.querySelectorAll("head [data-prerender]").forEach((n) => n.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
